export default "__VITE_ASSET__BTTOz53j__"